// React Lib
import React from 'react';
// Component Styles
import { useStyles } from './MaximizedSystemLogStyles';
// @otg-one/ui_components/components
import { OntegoSwitch, Chip, Typography, Separator } from '../index';
import { Bug, Download } from '../../icons';
// @otg-one/ui_components/constants
import { Color, FONT_FAMILY, getLogSeverityStyle } from "../../constants";
// Material UI Core
import Grid from '@mui/material/Grid';
import { Button } from '../Button';
const SystemLogListHeader = (props) => {
    const classes = useStyles(props);
    const { textStatus, textDeviceId, textLastLogin, textDebug, textDownload } = props;
    return (React.createElement(React.Fragment, null,
        React.createElement(Grid, { item: true, md: 2 },
            React.createElement(Typography, { fontFamily: FONT_FAMILY.ROBOTO_BOLD, size: 14, color: Color.neutral[100] }, textStatus)),
        React.createElement(Grid, { item: true, md: 3 },
            React.createElement(Typography, { fontFamily: FONT_FAMILY.ROBOTO_BOLD, size: 14, color: Color.neutral[100] }, textDeviceId)),
        React.createElement(Grid, { item: true, md: 3 },
            React.createElement(Typography, { fontFamily: FONT_FAMILY.ROBOTO_BOLD, size: 14, color: Color.neutral[100] }, textLastLogin)),
        React.createElement(Grid, { item: true, md: 2 },
            React.createElement(Typography, { fontFamily: FONT_FAMILY.ROBOTO_BOLD, size: 14, color: Color.neutral[100] }, textDebug)),
        React.createElement(Grid, { item: true, md: 2 },
            React.createElement(Typography, { fontFamily: FONT_FAMILY.ROBOTO_BOLD, size: 14, color: Color.neutral[100] }, textDownload)),
        React.createElement(Grid, { item: true, md: 12 },
            React.createElement(Separator, { type: "n200", width: 2, marginTop: -8 }))));
};
const SystemLogList = (props) => {
    const { log, handleChangeDebug, textDownload } = props;
    return (React.createElement(React.Fragment, null,
        React.createElement(Grid, { item: true, md: 2 },
            React.createElement("div", { style: { marginTop: -10 } },
                React.createElement(Chip, { backgroundColor: getLogSeverityStyle(log.textStatus).backgroundColor, color: getLogSeverityStyle(log.textStatus).fontColor }, log.textStatus))),
        React.createElement(Grid, { item: true, md: 3 },
            React.createElement(Typography, { fontFamily: FONT_FAMILY.ROBOTO_REGULAR, size: 14, color: Color.neutral[100], style: { marginTop: -10 } }, log.textDeviceId)),
        React.createElement(Grid, { item: true, md: 3 },
            React.createElement(Typography, { fontFamily: FONT_FAMILY.ROBOTO_REGULAR, size: 14, color: Color.neutral[100], style: { marginTop: -10 } }, log.textLastLogin)),
        React.createElement(Grid, { item: true, md: 2 },
            React.createElement("div", { style: { marginTop: -10, display: 'flex', alignItems: 'center' } },
                React.createElement(OntegoSwitch, { checked: log.isDebug, handleChange: e => handleChangeDebug(e, log) }),
                React.createElement(Bug, { style: { width: 24, height: 24, color: log.isDebug ? Color.primary[500] : Color.neutral[300], marginLeft: 8 } }))),
        React.createElement(Grid, { item: true, md: 2 },
            React.createElement("div", { style: { marginTop: -14, display: 'flex', alignItems: 'center' } },
                React.createElement(Button, { type: "secondary", color: "white", alignIcon: "left", icon: React.createElement(Download, null) }, textDownload)))));
};
export const MaximizedSystemLog = (props) => {
    const classes = useStyles(props);
    const { id, logs, handleChangeDebug, style, textStatus, textDeviceId, textLastLogin, textDebug, textDownload } = props;
    return (React.createElement("div", { id: id, className: classes.systemLogContainer, style: style },
        React.createElement("div", { id: `${id}-latest-activity-list-container`, className: classes.systemLogListContainer },
            React.createElement(Grid, { container: true, style: { flexGrow: 1 }, spacing: 2, alignItems: "center" },
                React.createElement(SystemLogListHeader, { textStatus: textStatus, textDeviceId: textDeviceId, textLastLogin: textLastLogin, textDebug: textDebug, textDownload: textDownload }),
                logs.map((log, index) => (React.createElement(React.Fragment, null,
                    React.createElement(SystemLogList, { log: log, handleChangeDebug: handleChangeDebug, textDownload: textDownload }),
                    index !== logs.length - 1 && (React.createElement(Grid, { item: true, md: 12 },
                        React.createElement(Separator, { type: "n200", width: 1, marginTop: -8 }))))))))));
};
MaximizedSystemLog.defaultProps = {
    logs: [],
    textStatus: 'Status',
    textDeviceId: 'Device ID',
    textLastLogin: 'Last Login',
    textDebug: 'Debug',
    textDownload: 'Download',
};
export default React.memo(MaximizedSystemLog);
